import { Compound, CompoundReference } from "../system/Domain";
import { Box, Tooltip, Typography } from "@mui/material";
import TextBlock from "./Layout/TextBlock";

interface Props {
	compoundRef: CompoundReference
	compounds: Compound[]
}

const CompoundPill = (props: Props) => {
	const compound = props.compounds?.find(c => c.name === props.compoundRef.name);

	if (!compound) {
		return <></>;
	}

	return (
		<Tooltip title={
			<Typography component="div">
				{compound.address.name}<br />
				{compound.address.zipCode} - {compound.address.city} - {compound.address.street}
			</Typography>}>
			<Box sx={{ width: "fit-content" }}>
				<TextBlock
					chip={{
						label: compound?.name,
						color: "default"
					}}
				/>
			</Box>
		</Tooltip>
	);
};

export default CompoundPill;
